import { Button, Input, Segmented } from "antd";
import { CalendarDays, LayoutGrid, Settings, Table2 } from "lucide-react";
import { useTranslation } from "react-i18next";
import AssignFilter from "./Filters/AssignFilter";
import StatusFilter from "./Filters/StatusFilter";
import TimeFilter from "./Filters/TimeFilter";
import { FilterState } from "../../pages/ChuyenMon/Customer";
import { AppointmentStatusScope } from "../../api/Appointment";
import {
    SearchOutlined,
} from "@ant-design/icons";

const HeaderActions = ({
    view, setView, showStats, setShowStats, filters, onFiltersChange, onSearch, extra, statusScope
}: {
    view: string;
    setView: (view: string) => void;
    showStats: boolean;
    setShowStats: (show: boolean) => void;
    filters: FilterState;
    onFiltersChange: (next: FilterState) => void;
    onSearch: (value: string) => void;
    /** Nút phụ đặt sau công tắc chế độ xem (vd: cài đặt cột khi đang xem dạng bảng) */
    extra?: React.ReactNode;
    /** Màn hình tư vấn / thực hiện có tập trạng thái lọc riêng */
    statusScope?: AppointmentStatusScope;
}) => {
    const { t } = useTranslation();

    // Chế độ xem để thẳng ngoài toolbar (không bọc dropdown) để đổi trong 1 click.
    const viewOptions = [
        {
            value: "table",
            label: (
                <span className="flex items-center gap-1.5">
                    <Table2 size={16} />
                    <span className="hidden sm:inline">{t("lead.table_view") || "Bảng"}</span>
                </span>
            ),
        },
        {
            value: "pipeline",
            label: (
                <span className="flex items-center gap-1.5">
                    <LayoutGrid size={16} />
                    <span className="hidden sm:inline">{t("lead.pipeline_view") || "Tiến trình"}</span>
                </span>
            ),
        },
        {
            value: "calendar",
            label: (
                <span className="flex items-center gap-1.5">
                    <CalendarDays size={16} />
                    <span className="hidden sm:inline">{t("lead.calendar_view") || "Lịch"}</span>
                </span>
            ),
        },
    ];

    return (
        <div className="flex items-center justify-between flex-wrap gap-2">
            {/* Filters */}
            <div className="flex gap-2 flex-wrap">
                {/* Search */}
                <div className="flex items-center px-3 flex-1 md:w-[260px] bg-white dark:bg-[#1f1f1f] border border-[#d9d9d9] dark:border-[#303030] rounded-md">
                    <SearchOutlined className="text-gray-500" />
                    <Input
                        bordered={false}
                        placeholder={t('customer.search_placeholder')}
                        onChange={(e) => onSearch(e.target.value)}
                    />
                </div>
                <AssignFilter
                    value={filters.staffIds}
                    onChange={(staffIds) => onFiltersChange({ ...filters, staffIds })}
                />
                <StatusFilter
                    value={filters.statuses}
                    onChange={(statuses) => onFiltersChange({ ...filters, statuses })}
                    scope={statusScope}
                />
                <TimeFilter
                    value={filters.timeKey}
                    onChange={(timeKey) => onFiltersChange({ ...filters, timeKey })}
                />
            </div>

            {/* Actions */}
            <div className="flex gap-2">
                {/* Toggle stats: đang tạm ẩn */}
                <Button
                    className={`d-none ${showStats ? "text-[#3e91ab] border-[#3e91ab]" : ""}`}
                    icon={<Settings size={16} />}
                    onClick={() => setShowStats(!showStats)}
                />

                {/* Chuyển giữa dạng bảng và dạng cột kéo thả theo trạng thái */}
                <Segmented
                    value={view}
                    onChange={(value) => setView(String(value))}
                    options={viewOptions}
                />

                {extra}
            </div>
        </div>
    );
};

export default HeaderActions;